import { fromJS } from 'immutable';
import { SET_ERROR_IMPORT, SET_SUBSIDIARY } from '../../actions/subsidiary/types';
import { createReducer } from '../../reduxTools/tools';

const initialState = fromJS({
  importSubsidiaries: [],
  importErrorSubsidiaries: {},
});

const setSubsidiary = (state, action) => {
  let newState = state;
  const subsidiary = action.payload;
  newState = newState.setIn(['SET_SUBSIDIARY'], subsidiary);
  return newState;
};

const setErrorImportSubsidiaries = (state, action) => {
  let newState = state;
  const current = newState?.toJS()?.importErrorSubsidiaries || {};
  newState = newState.setIn(['SET_SUBSIDIARY'], { ...current, ...action.payload });
  return newState;
};

const EVENTS = {
  [SET_SUBSIDIARY]: setSubsidiary,
  [SET_ERROR_IMPORT]: setErrorImportSubsidiaries,
};
const reducer = createReducer(initialState, EVENTS);

export default reducer;